var _path, _path2, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-save"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10452"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 383",
    d: "M6.88911 7.37158H3.2793V15.4938H17.7186V7.37158H14.1087",
    stroke: "white",
    strokeWidth: 1.08295
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1215"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 176",
    d: "M10.5 1.50478L10.5 10.0509L10.5 12.2949",
    stroke: "white",
    strokeWidth: 1.08295
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3290_188075",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 9,
    width: 11,
    height: 5
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 272",
    width: 3.98004,
    height: 10.3214,
    transform: "matrix(-1.19247e-08 1 1 1.19251e-08 5.53516 9.5957)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3290_188075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 177",
    d: "M5.98633 8.0189L10.4986 12.5313L15.0109 8.0189",
    stroke: "white",
    strokeWidth: 1.08295
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDownload);
export default __webpack_public_path__ + "static/media/btn-download.594647e56166094c12fe69dccd293ba8.svg";
export { ForwardRef as ReactComponent };